import PropTypes from "prop-types";
import { useSelector } from "react-redux";

function AdminOnly({ children }) {
  const { isAdmin } = useSelector((state) => state.login);

  if (!isAdmin) {
    return null;
  }

  return children;
}

AdminOnly.propTypes = {
  children: PropTypes.any,
};

export default AdminOnly;
